import {
  getClassroomAvatarColor,
  getDefaultClassroomBackgroundRef,
} from '@/shared/features/classroom/utils/classroomAvatarColor';

/**
 * 클래스 썸네일 색(`getClassroomAvatarColor` 의 5색 팔레트)에 대응하는 배경 gradient tint.
 * 썸네일 색을 그대로 받아 매핑해야 썸네일과 그라데이션 색이 어긋나지 않는다.
 */
const CLASSROOM_GRADIENT_TINT_COLORS: Record<string, string> = {
  '#ff8d24': '#FFE5C3',
  '#00ba4a': '#D0FAD4',
  '#5793f9': '#CFEAFF',
  '#b179d2': '#DBC4FF',
  '#ff7bb7': '#FFD0FF',
};

const getClassroomGradientTintColor = (seed?: string) => {
  const { avatarColor } = getClassroomAvatarColor(
    getDefaultClassroomBackgroundRef(seed),
  );
  return (
    CLASSROOM_GRADIENT_TINT_COLORS[avatarColor.toLowerCase()] ?? avatarColor
  );
};

const hexToRgbString = (hexColor: string) =>
  `${parseInt(hexColor.slice(1, 3), 16)}, ${parseInt(
    hexColor.slice(3, 5),
    16,
  )}, ${parseInt(hexColor.slice(5, 7), 16)}`;

export const getClassroomGradientBackground = (seed?: string) => {
  const tintRgb = hexToRgbString(getClassroomGradientTintColor(seed));

  return `linear-gradient(180deg, #FFF 0%, rgba(${tintRgb}, 0.11) 20%, rgba(${tintRgb}, 0.25) 50%, rgba(${tintRgb}, 0.11) 80%, #FFF 100%)`;
};
